import React, { useEffect, useState } from "react";
import axios from "axios";
import { Users, Send, MessageCircle, BookOpen } from "lucide-react";
import { Link } from "react-router-dom";
import { loadPixel, track, waLink } from "../components/join/pixel";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function BigLink({ href, onClick, testid, className, icon: Icon, title, sub }) {
  return (
    <a href={href} target="_blank" rel="noreferrer" onClick={onClick} data-testid={testid}
      className={`w-full flex items-center gap-4 px-5 py-5 font-bold active:scale-[0.98] transition-transform duration-150 ${className}`}>
      <Icon size={28} className="shrink-0" />
      <span className="text-left">
        <span className="block text-lg sm:text-xl leading-tight">{title}</span>
        <span className="block text-xs font-medium opacity-80 mt-0.5">{sub}</span>
      </span>
    </a>
  );
}

export default function Join() {
  const [cfg, setCfg] = useState({ brand: "Fateh FX" });
  useEffect(() => {
    document.title = "Free Gold Signals | Fateh FX";
    axios.get(`${API}/public/join-config`).then(({ data }) => { setCfg(data); loadPixel(data.meta_pixel_id); }).catch(() => {});
  }, []);
  const wa = waLink(cfg.wa_chat_number, `Hi ${cfg.brand}, I'd like to join your Gold signals.`);
  return (
    <div className="min-h-[100dvh] flex flex-col items-center justify-center px-5 py-10 text-white" style={{ background: "#0A0A0B" }} data-testid="join-page">
      <div className="w-full max-w-md join-rise">
        <div className="flex items-center gap-2.5 mb-8">
          <div className="w-9 h-9 flex items-center justify-center bg-gold text-black font-head font-bold">F</div>
          <span className="font-head font-bold text-lg">{cfg.brand}</span>
        </div>
        <h1 className="font-head text-4xl sm:text-5xl font-bold tracking-tight leading-[1.05]">
          Free Gold Signals.<br /><span className="text-gold">8–10 daily.</span>
        </h1>
        <p className="mt-4 text-slate-400 text-base">Entry, SL &amp; TP on every call. Join free now.</p>
        <div className="mt-8 space-y-3">
          {cfg.wa_community && (
            <BigLink href={cfg.wa_community} testid="join-wa-community" onClick={() => track("Contact", { channel: "whatsapp_community" })}
              className="bg-[#25D366] text-black shadow-[0_10px_40px_rgba(37,211,102,0.35)] ring-2 ring-[#25D366]/40 ring-offset-2 ring-offset-[#0A0A0B]"
              icon={Users} title="Join WhatsApp Community" sub="Free · 1 tap to join" />
          )}
          {cfg.free_telegram_url && (
            <BigLink href={cfg.free_telegram_url} testid="join-tg-free" onClick={() => track("Contact", { channel: "telegram_free" })}
              className="bg-[#2AABEE] text-white" icon={Send} title="Join Telegram Channel" sub="Free · Live signals & results" />
          )}
        </div>
        {wa && (
          <a href={wa} target="_blank" rel="noreferrer" onClick={() => track("Contact", { channel: "whatsapp_chat" })} data-testid="join-wa-chat"
            className="mt-6 inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white transition-colors duration-200">
            <MessageCircle size={15} />Questions? Message us on WhatsApp
          </a>
        )}
        <Link to="/tutorial" data-testid="join-tutorial-link" className="mt-3 flex items-center gap-2 text-sm text-slate-400 hover:text-gold transition-colors duration-200"><BookOpen size={15} />How to trade our calls</Link>
        <p className="mt-10 text-[10px] text-slate-600 leading-relaxed">Trading involves high risk. Past performance does not guarantee future results.</p>
      </div>
    </div>
  );
}
